export function cnsMask(value = '', defaultEmptyReturn = ''): string {
  if (!value) return defaultEmptyReturn

  return value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1-$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(\d{4})(\d{1,2})/, '$1-$2')
    .replace(/(.\d{4})\d+?$/, '$1')
}
